<template>
    <Navbar />
    <div class="register">
       <ResetPwd/>
    </div>
  </template>
  
  <script setup>
  import Navbar from '../components/Navbar.vue'
  import { computed } from 'vue'
  import ResendEmail from '../components/ResendEmail.vue'  
  import ResetPwd from '../components/ResetPwd.vue'

  
  </script>
  
  
  <style scoped>
  .register {
    width: 100%;
    min-height: 100vh; /* ✅ 改成 min-height，避免卡片內容過多時爆版 */
    background-color: var(--color-primary-bg);
    display: flex;
    justify-content: center;
    align-items: flex-start; /* ✅ 垂直置頂，不要強制置中讓卡片過長 */
    padding: 80px 32px;
    box-sizing: border-box;
  }
  
  /* ✅ 手機版左右 padding 收窄 */
  @media (max-width: 768px) {
    .register {
      padding: 32px 16px;
    }
  }
  
  
  </style>
  
